import type { SearchFilters } from '@/types/search-filters';
import type { CrmAccountView } from '@/types/custom-playbooks';
import type { CompanySearchFilters } from '@/utils/company-search.utils';

export type AgentPeopleFilters = SearchFilters & {
  joinedCurrentWithinDays?: number;
  /** Current employers are the CRM accounts this view matches, read live. */
  currentCompanyDomainsFromCrm?: CrmAccountView;
  /** Current employers are companies on this saved list, read live. */
  currentCompanyDomainsFromList?: { listId: string };
};
export type AgentCompanyFilters = CompanySearchFilters & {
  lastFundingWithinDays?: number;
  ipoWithinDays?: number;
  domainsFromList?: { listId: string };
  lookalikeOf?: { domains: string[]; refreshDays: number };
};
export const MAX_TARGET_DOMAINS = 500;

export function fundingFiltered(filters: AgentCompanyFilters) {
  return !!(
    filters.lastFundingWithinDays ||
    filters.lastFundingDateAfter ||
    filters.fundingRoundTypes.length ||
    filters.fundingRoundTypesExclude.length ||
    filters.lastFundingRoundAmountMin ||
    filters.lastFundingRoundAmountMax
  );
}
